import React from 'react';
import Header from '../components/Layout/Header';
import StockAnalysisChatbot from '../components/Trading/StockAnalysisChatbot';
import { useAuthStore } from '../stores';

const AIChatPage: React.FC = () => {
    const { user, logout } = useAuthStore();

    const handleLogout = () => {
        logout();
        window.location.href = '/login';
    };

    // Allow access even without user for demo purposes
    // The chatbot will work for everyone

    return (
        <div className="min-h-screen w-full max-w-full overflow-x-hidden bg-gray-50 dark:bg-gray-900 flex flex-col">
            {/* Conditional Header - only show if user is logged in */}
            {user && <Header user={user} onLogout={handleLogout} />}

            {/* Full-screen Chatbot */}
            <div className={user ? "h-[calc(100vh-64px)] w-full max-w-full min-w-0 overflow-x-hidden" : "h-screen w-full max-w-full min-w-0 overflow-x-hidden"}>
                <StockAnalysisChatbot />
            </div>
        </div>
    );
};

export default AIChatPage;
